// components/CitySelect.tsx
import React from "react";
import MasterDropdown from "../common/MasterDropdown";
import type { MasterOption } from "../common/MasterDropdown";

// Static city options, grouped by stateName (no API)
const CITY_OPTIONS: MasterOption[] = [
  // Maharashtra
  { value: "Mumbai", label: "Mumbai", stateName: "Maharashtra" },
  { value: "Pune", label: "Pune", stateName: "Maharashtra" },
  { value: "Nagpur", label: "Nagpur", stateName: "Maharashtra" },
  { value: "Nashik", label: "Nashik", stateName: "Maharashtra" },
  // Karnataka
  { value: "Bengaluru", label: "Bengaluru", stateName: "Karnataka" },
  { value: "Mysuru", label: "Mysuru", stateName: "Karnataka" },
  // Gujarat
  { value: "Ahmedabad", label: "Ahmedabad", stateName: "Gujarat" },
  { value: "Surat", label: "Surat", stateName: "Gujarat" },
  // Delhi
  { value: "New Delhi", label: "New Delhi", stateName: "Delhi" },
  // Tamil Nadu
  { value: "Chennai", label: "Chennai", stateName: "Tamil Nadu" },
  { value: "Coimbatore", label: "Coimbatore", stateName: "Tamil Nadu" },
  // Telangana
  { value: "Hyderabad", label: "Hyderabad", stateName: "Telangana" },
];

interface CitySelectProps {
  state?: string | number; // State name (string) or state ID (number) for backward compatibility
  value: string | number | null | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStateChange?: (stateName: string, stateId: number) => void;
  required?: boolean;
  label?: string;
  name?: string;
  disableClearable?: boolean;
  disabled?: boolean;
}

const CitySelect: React.FC<CitySelectProps> = ({
  state,
  value,
  onChange,
  onStateChange,
  required = false,
  label = "City",
  name = "city",
  disabled = false,
}) => {
  // Filter cities by selected state, if provided
  const options =
    state && typeof state === "string"
      ? CITY_OPTIONS.filter((c) => c.stateName === state)
      : CITY_OPTIONS;

  const handleChange = (newValue: string | number | null) => {
    // Mimic old event structure for backward compatibility
    const fakeEvent = {
      target: {
        name,
        value: newValue || "",
      },
    } as React.ChangeEvent<HTMLInputElement>;
    onChange(fakeEvent);

    // If a city is selected, set the state automatically
    if (newValue && onStateChange) {
      const selectedOption = options.find(
        (opt) => String(opt.value) === String(newValue)
      );

      if (selectedOption && selectedOption.stateName) {
        onStateChange(selectedOption.stateName, selectedOption.stateId || 0);
      }
    } else if (!newValue && onStateChange) {
      // If city is cleared, clear the state as well
      onStateChange("", 0);
    }
  };

  return (
    <MasterDropdown
      options={options}
      value={value}
      onChange={handleChange}
      loading={false}
      label={label}
      name={name}
      required={required}
      disableClearable={false}
      fullWidth
      disabled={disabled}
    />
  );
};

export default CitySelect;
